import { OPPORTUNITIES_TABS } from 'core/constants';
import qs from 'qs';
import { urls } from 'core/appUrls';

export const getRedirectUrlWithTabHelper = (tab: OPPORTUNITIES_TABS): string => {
	const tabValue = qs.stringify({ tab });

	return `${urls.supperAdminOppoList}?${tabValue}`;
};
